import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import { Col } from 'reactstrap';
import propTypes from 'prop-types';

export default class Header extends Component{
    render(){
        return(
            <Col xs={12} className="size-header">
                <div className="title">
                    {this.props.children}                
                </div>
            </Col>
        )
    }
}

Header.propTypes={
    children:propTypes.element.isRequired
}